module.exports = __webpack_public_path__ + "img/download_btn.3f70291d.png";